export default __webpack_public_path__ + "static/media/Kids.95e3d7fe.png";